$(document).ready(function(){
  var DateTime = luxon.DateTime;
  var d = new DateTime.local().setZone('America/Chicago');
  //console.log(d.toString());
  var dateDayString = d.day.toString();
  if (dateDayString.length == 1) {
    var dateDayString = "0" + dateDayString;
  }
  var dateMonthString = (d.month).toString();
  if (dateMonthString.length == 1) {
    var dateMonthString = "0" + dateMonthString;
  }
  var strDate = d.year.toString() + dateMonthString + dateDayString;
  var strDateNum = parseInt(strDate);
  var startingDivs = $('*[class*="start"]');
  //console.log(startingDivs);
  //console.log(startingDivs[0].className.split(/\s+/));
  var i;
  for (i = 0; i < startingDivs.length; i++) {
    var classList = startingDivs[i].className.split(/\s+/);
    var j;
    for (j = 0; j < classList.length; j++) {
      if (classList[j].startsWith("start")) {
        var startDateNum = parseInt(classList[j].split("-")[1]);
        //console.log("Div Start: " + startDateNum);
        //console.log("Today: " + strDateNum);
        if (startDateNum > strDateNum) {
          $(startingDivs[i]).hide();
        }
      }
      if (classList[j].startsWith("end")) {
        var endDateNum = parseInt(classList[j].split("-")[1]);
        //console.log(endDateNum);
        if (endDateNum < strDateNum) {
          $(startingDivs[i]).hide();
        }
      }
    }
  }
});